import { STICKY_NOTE_COLORS, type StickyNoteColor } from '@backrs_ui/common-ui';

import type { Theme } from '@mui/material';

export const STICKY_NOTE_WIDTH = 224;
export const STICKY_NOTE_HEIGHT = 221;

/** Vertical offset between successive notes in the deck. */
export const STICKY_NOTE_DECK_STEP = 44;

/** Height of the strip along a card's top edge that holds the drag handle and controls. */
export const STICKY_NOTE_STRIP_HEIGHT = 44;

export const STICKY_NOTE_MAX_LENGTH = 20000;

/** Keys are persisted: restyle a slot, never renumber one. */
export const getStickyNoteColor = ({ backrs }: Theme, color: StickyNoteColor): string => {
  switch (color) {
    case 'color_2':
      return backrs.colors['Brand/500'];
    case 'color_3':
      return backrs.colors['Success/500'];
    case 'color_4':
      return backrs.colors['Error/400'];
    case 'color_5':
      return backrs.colors['Colors/Base/Black'];
    case 'color_6':
      return backrs.colors['Brand/100'];
    case 'color_1':
    default:
      return backrs.colors['Warning/400'];
  }
};

export const getStickyNoteTextColor = ({ backrs }: Theme, color: StickyNoteColor): string =>
  color === 'color_5'
    ? backrs.colors['Colors/Text/text-tertiary']
    : backrs.colors['Colors/Text/text-primary'];

/** Picker order, independent of the persisted key order. */
const SWATCH_RANK: Record<StickyNoteColor, number> = {
  color_1: 0,
  color_4: 1,
  color_2: 2,
  color_3: 3,
  color_6: 4,
  color_5: 5,
};

export const STICKY_NOTE_SWATCH_ORDER: readonly StickyNoteColor[] = [...STICKY_NOTE_COLORS].sort(
  (a, b) => SWATCH_RANK[a] - SWATCH_RANK[b],
);
